<script setup lang="ts">
import { AppSvgIcon, AppFlicker } from '@libs/ui';

import type { CarTripInfo } from '../../models/editCarTripView.model';

interface CarTransportProps {
  carTripInfo?: CarTripInfo;
}
const props = defineProps<CarTransportProps>();
</script>

<template>
  <div class="car-transport-segment">
    <div class="icon">
      <AppSvgIcon name="car" color="color-white" size="18" />
    </div>
    <div class="info">
      <span>{{ $t('planner.transport.driving_a_car') }}</span>
      <div class="time-and-distance">
        <span v-if="props.carTripInfo?.duration">
          {{ props.carTripInfo.duration }}
        </span>
        <AppFlicker
          v-else
          height="spacing-16"
          width="spacing-64"
          border-radius="border-radius-12"
        />

        <span v-if="props.carTripInfo?.distance">
          {{ props.carTripInfo.distance }}
        </span>
        <AppFlicker
          v-else
          height="spacing-16"
          width="spacing-64"
          border-radius="border-radius-12"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.car-transport-segment {
  padding: var(--spacing-16);
  display: flex;
  gap: var(--spacing-16);
  align-items: center;
  position: relative;
  .icon {
    background-color: var(--color-neutral-70);
    border-radius: var(--border-radius-8);
    padding: var(--spacing-4);

    display: flex;
    align-items: center;
    justify-content: center;
  }
  .info {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    gap: var(--spacing-4);
    @include font-label-l-bold;
    @include for-less-or-equal-than-899-px {
      @include font-label-s-bold;
    }
    .time-and-distance {
      @include font-label-s-light;
      display: flex;
      gap: var(--spacing-16);
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 28px;
    width: 0;
    height: 100%;
    border: 1px dashed var(--color-neutral-70);
    z-index: -1;
  }
}
</style>
